export default {
  max_amount_error: {
    en: 'Maximum number of generated emails reached for today.',
    de: 'Maximale Anzahl generierter E-Mails für heute erreicht.',
  },

  general_error: {
    en: 'Something went wrong. Please try again.',
    de: 'Etwas ist schief gelaufen. Bitte versuche es erneut.',
  },

  email_on_waitlist: {
    en: 'Email is already on the waitlist.',
    de: 'E-Mail ist bereits auf der Warteliste.',
  },

  incomplete_data: {
    en: 'Please make sure your input is complete and valid.',
    de: 'Bitte stell sicher, dass deine Eingabe vollständig und gültig ist.',
  },

  website_not_found: {
    en: 'We couldn’t find this website. Please check if it exists.',
    de: 'Wir konnten diese Website nicht finden. Schau bitte nach, ob sie existiert.',
  },

  research_issue: {
    en: 'We ran into some issues researching this company. Please try again.',
    de: 'Es gab Probleme bei der Recherche zu dieser Firma. Versuch es bitte nochmal.',
  },

  stream_issue: {
    en: 'The connection got interrupted. Sorry about that! Please try again.',
    de: 'Die Verbindung wurde unterbrochen. Sorry! Versuch es bitte nochmal.',
  },
}
